export function generateId() {
    return crypto.randomUUID().split('-')[0] as string
}